import { render, staticRenderFns } from "./Form20Resolution.vue?vue&type=template&id=d2c36772&scoped=true&"
import script from "./Form20Resolution.vue?vue&type=script&lang=js&"
export * from "./Form20Resolution.vue?vue&type=script&lang=js&"
import style0 from "./Form20Resolution.vue?vue&type=style&index=0&id=d2c36772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c36772",
  null
  
)

export default component.exports